// Centralized route names for the Factoring module
export const FACTORING_ROUTES = {
  PATH: '/factoringUser',
  INDEX: '',
  IMPORT: 'import',
  IMPORT_SUMMARY: 'import-summary',
  REQUESTS: 'requests',
  REQUESTS_LIST: 'list',
  REQUESTS_DETAIL: (id = ':requestId') => `detail/${id}`,
  REQUESTS_INVOICE: 'invoice',
  REQUESTS_AUTHORIZATION: (id = ':requestId') => `authorization/${id}`,
  REQUESTS_SUMMARY: 'summary',
  AVAILABLE_INVOICES: 'discount',
  UPLOAD_HISTORY: 'upload-history',
  UPLOAD_HISTORY_DETAIL: (id = ':loadId') => `upload-history-detail/${id}`,
  UPLOAD_HISTORY_INVOICE: 'upload-history-invoice',
  HISTORICAL_DISBURSEMENTS: 'historical-disbursements',
  HISTORICAL_DISBURSEMENT_DETAIL: 'historical-disbursement-detail/:idcreditform',
  NOT_FOUND: '/404'
};
